import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=31b4f336&scoped=true&"
import script from "./CardPage.vue?vue&type=script&lang=js&"
export * from "./CardPage.vue?vue&type=script&lang=js&"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=31b4f336&scoped=true&lang=css&"
import style1 from "./CardPage.vue?vue&type=style&index=1&id=31b4f336&scoped=true&lang=css&"
import style2 from "./CardPage.vue?vue&type=style&index=2&id=31b4f336&scoped=true&lang=css&"
import style3 from "./CardPage.vue?vue&type=style&index=3&id=31b4f336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4f336",
  null
  
)

export default component.exports